import * as React from "react";
import { createGlobalStyle } from "styled-components";
import Layout from "../components/Layout";
import "../styles/fonts.css";
import reset from "../styles/reset";
import global from "../styles/global";
import CookiesBanner from "../components/CookiesBanner";
import { ErrorBoundary } from "@bumble/react-error-boundary";
import { logger, useGelatoLogger } from "../lib/use-gelato-logger";
import {useEffect} from "react";

const GlobalStyles = createGlobalStyle`
  ${reset}
  ${global}
`;

function MyApp({ Component, pageProps }) {
  useGelatoLogger();

  return (
    <React.StrictMode>
      <ErrorBoundary
        debug={false}
        logger={(error, errorDetails) => {
          if (process.env.NODE_ENV === 'production') {
            logger.trackError(error, {
              ...errorDetails,
              origin: "ErrorBoundary",
              debugInfo: errorDetails?.debug_info,
            });
          }
        }}
      >
        <GlobalStyles />
        <CookiesBanner />
        <Layout>
          <Component {...pageProps} />
        </Layout>
      </ErrorBoundary>
    </React.StrictMode>
  );
}

export default MyApp;
